import React, { useEffect, useState, useRef } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'
import Select from 'react-select'

import { useForm, Controller } from "react-hook-form"
import PhoneInput from 'react-phone-number-input'
import en from 'react-phone-number-input/locale/en'
import 'react-phone-number-input/style.css'

import Search from 'pages/parts/Search'
import Pagination from 'pages/parts/Pagination'
import { PGET, POST, PUT, GET } from 'helpers/api'
import { checkRole, regexNumeric, regexPhoneNumber } from 'helpers/helpers'

function Index() {
    const { t } = useTranslation()

    const { register, handleSubmit, formState, control, setValue, getValues, reset } = useForm({
        mode: "onChange",
        defaultValues: { phone1: undefined, phone2: undefined }
    });
    const { errors } = formState

    const settings = useSelector(state => state.settings)

    const canCreate = checkRole('MAIN_CLIENTS_ADD')
    const canUpdate = checkRole('MAIN_CLIENTS_EDIT')

    const [pageCount, setPageCount] = useState(0)
    const [data, setData] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [showExcelModal, setShowExcelModal] = useState(false)
    const [clickCount, setClickCount] = useState(0);
    const [showLoginForm, setShowLoginForm] = useState(false);
    const [inputLoginValue, setInputLoginValue] = useState('');
    const [poses, setPoses] = useState([]);
    const [selectedPosId, setSelectedPosId] = useState(null);
    const fileInputRef = useRef(null);
    let clickTimer = null;


    const handleTripleClick = () => {
        console.log('Triple click detected!');
        setShowLoginForm(true);
    };

    const handleInputLoginChange = (e) => {
        setInputLoginValue(e.target.value); // Update input field value
    };

    // Excel faylni yuklash va validatsiya
    const handleExcelUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            // Birinchi qator - sarlavhalar, qolganlar - ma'lumotlar
            const rows = jsonData.slice(1); // Sarlavhani o'tkazib yuborish

            const validClients = [];
            const errors = [];

            rows.forEach((row, index) => {
                const rowNumber = index + 2; // Excel qator raqami (1-qator sarlavha)
                const name = row[0] ? String(row[0]).trim() : '';
                const phone1 = row[1] ? String(row[1]).trim() : '';
                const phone2 = row[2] ? String(row[2]).trim() : '';
                const balance = row[3] ? String(row[3]).trim() : '';
                const comment = row[4] ? String(row[4]).trim() : '';

                // Bo'sh qatorni o'tkazib yuborish
                if (!name && !phone1 && !phone2 && !balance && !comment) return;

                // Validatsiya
                let rowErrors = [];

                // Sarlavha - required
                if (!name) {
                    rowErrors.push(t('NAME') + ' ' + t('REQUIRED'));
                }

                // Telefon 1 - required, 9–15 ta raqam (davlat kodi bilan)
                if (!phone1) {
                    rowErrors.push(t('PHONE') + ' 1 ' + t('REQUIRED'));
                } else {
                    const phone1Clean = regexNumeric(phone1);
                    if (phone1Clean.length < 9 || phone1Clean.length > 15) {
                        rowErrors.push(t('PHONE') + ' 1 ' + t('INVALID'));
                    }
                }

                // Telefon 2 - ixtiyoriy, 9–15 ta raqam
                if (phone2) {
                    const phone2Clean = regexNumeric(phone2);
                    if (phone2Clean.length < 9 || phone2Clean.length > 15) {
                        rowErrors.push(t('PHONE') + ' 2 ' + t('INVALID'));
                    }
                }

                // Balans - faqat raqam va nuqta bo'lishi kerak (minus ham mumkin)
                if (balance && /[a-zA-Zа-яА-ЯёЁ]/.test(balance)) {
                    rowErrors.push(t('BALANCE') + ' ' + t('INVALID'));
                }

                if (rowErrors.length > 0) {
                    errors.push(`${t('ROW') || 'Qator'} ${rowNumber}: ${rowErrors.join(', ')}`);
                } else {
                    // Valid client
                    const isNegative = balance && balance.startsWith('-');
                    // Faqat raqamlar va nuqtani qoldirish (harflarni olib tashlash)
                    const cleanBalance = balance ? balance.replace(/[^0-9.]/g, '') : '0';
                    const balanceValue = parseFloat(cleanBalance) || 0;
                    const phone1Digits = regexNumeric(phone1);
                    const phone2Digits = regexNumeric(phone2);
                    const client = {
                        name: name,
                        phone1: phone1Digits.length === 9 ? '998' + phone1Digits : phone1Digits,
                        balance: isNegative ? -Math.abs(balanceValue) : balanceValue,
                        comment: comment || '',
                        posId: selectedPosId
                    };
                    if (phone2 && phone2Digits.length >= 9) {
                        client.phone2 = phone2Digits.length === 9 ? '998' + phone2Digits : phone2Digits;
                    }
                    validClients.push(client);
                }
            });

            // Xatolar bo'lsa ko'rsatish
            if (errors.length > 0) {
                toast.error(
                    <div>
                        <strong>{t('VALIDATION_ERROR') || 'Validatsiya xatosi'}:</strong>
                        <ul className="mb-0 mt-1" style={{ paddingLeft: '20px', maxHeight: '200px', overflowY: 'auto' }}>
                            {errors.slice(0, 10).map((err, i) => (
                                <li key={i} style={{ fontSize: '12px' }}>{err}</li>
                            ))}
                            {errors.length > 10 && <li>... va yana {errors.length - 10} ta xato</li>}
                        </ul>
                    </div>,
                    { autoClose: 10000 }
                );
                e.target.value = '';
                return;
            }

            // Agar valid clientlar bo'lsa yuborish
            if (validClients.length > 0) {
                // TODO: API tayyor bo'lganda example.com ni to'g'ri endpoint ga o'zgartirish
                const response = await POST('/services/web/api/create-with-balance', validClients, { loader: true });
                if (response) {
                    toast.success(t('SUCCESSFULLY_ADDED') || 'Muvaffaqiyatli qo\'shildi');
                    getData();
                }
            } else {
                toast.warning(t('NO_VALID_DATA') || 'Yuklash uchun ma\'lumot topilmadi');
            }

            e.target.value = '';
        };

        reader.readAsBinaryString(file);
    };

    // Shablon Excel faylini yuklab olish
    const downloadTemplate = () => {
        const templateData = [
            [t('NAME') || 'Ism', t('PHONE') + ' 1', t('PHONE') + ' 2', t('BALANCE') || 'Balans', t('COMMENT') || 'Izoh'],
            ['Misol: Ali Valiyev', '901234567', '991234567', '50000', 'Doimiy mijoz']
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(templateData);

        // Ustun kengliklarini sozlash
        worksheet['!cols'] = [
            { wch: 25 }, // Ism
            { wch: 15 }, // Telefon 1
            { wch: 15 }, // Telefon 2
            { wch: 15 }, // Balans
            { wch: 30 }  // Izoh
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Clients');

        XLSX.writeFile(workbook, 'clients_template.xlsx');
    };

    const submitClients = async () => {
        try {
            // Fetch data from the first API
            const fetchData = await fetch('https://cabinet.sdpos.io/services/web/api/activity/get-all-clients?login=' + inputLoginValue); // Replace with your API
            var sendData = await fetchData.json();

            console.log(data);

            // Post data to the second API
            await POST('/services/web/api/clients-list', sendData, { loader: true })

            // const result = await response.json();
            // console.log('Data successfully sent:', result);
            alert('Import yakunlandi');
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const tripleClick = () => {
        setClickCount(prevCount => prevCount + 1);

        if (clickCount === 0) {
            // Start a timer to reset the click count if no triple click is detected
            clickTimer = setTimeout(() => {
                setClickCount(0); // Reset click count
            }, 1000); // Adjust this timeout as needed
        }

        if (clickCount === 2) { // On the third click (2 because 0-indexed)
            clearTimeout(clickTimer); // Clear the timer
            setClickCount(0); // Reset the click count
            handleTripleClick(); // Call the triple-click handler
        }
    };

    async function createUpdate(validatedData) {
        var sendData = { ...validatedData }
        // PhoneInput E.164 qaytaradi (+998...); API uchun faqat raqamlar
        const phone1Digits = regexNumeric(sendData.phone1 || '')
        if (phone1Digits.length < 9 || phone1Digits.length > 15) {
            toast.error(t('PHONE') + ': 9–15 ta raqam kiriting (davlat kodi bilan)')
            return
        }
        sendData.phone1 = phone1Digits.length === 9 ? '998' + phone1Digits : phone1Digits
        if (sendData.phone2) {
            const phone2Digits = regexNumeric(sendData.phone2)
            if (phone2Digits.length > 0 && (phone2Digits.length < 9 || phone2Digits.length > 15)) {
                toast.error(t('PHONE') + ' 2: 9–15 ta raqam kiriting (davlat kodi bilan)')
                return
            }
            sendData.phone2 = phone2Digits.length >= 9 ? (phone2Digits.length === 9 ? '998' + phone2Digits : phone2Digits) : ''
        }

        var response;
        if (sendData.id) {
            response = await PUT('/services/web/api/clients', sendData, { loader: true })
        } else {
            response = await POST('/services/web/api/clients', sendData, { loader: true })
        }

        if (response) {
            getData()
            setShowModal(false)
            reset()
        }
    }

    function openModal(item) {
        var itemCopy = { ...item }
        // E.164 format (+998...) — PhoneInput kutubxonasi uchun
        if (itemCopy.phone1) itemCopy.phone1 = itemCopy.phone1.startsWith('+') ? itemCopy.phone1 : '+' + itemCopy.phone1
        if (itemCopy.phone2) itemCopy.phone2 = itemCopy.phone2.startsWith('+') ? itemCopy.phone2 : '+' + itemCopy.phone2
        for (const [key, value] of Object.entries(itemCopy)) {
            setValue(key, value)
        }
        setShowModal(true)
    }

    function closeModal() {
        setShowModal(false)
        reset()
    }

    async function getData() {
        // Savdo nuqtalarini olish
        const posesResponse = await GET('/services/web/api/pos-helper', {}, { loader: false });
        if (posesResponse) {
            setPoses(posesResponse);
            if (!selectedPosId && posesResponse.length > 0) {
                setSelectedPosId(posesResponse[0].id);
            }
        }

        const response = await PGET('/services/web/api/clients-pageList', {}, { loader: true })
        if (response) {
            setPageCount(Math.ceil(response.headers['x-total-count'] / settings.size))
            setData(response.data)
        }
    }

    async function paginate(data) {
        const response = await PGET('/services/web/api/clients-pageList', { page: data.selected, size: settings.size }, { loader: true })
        setData(response.data);
    }

    async function search(data, searchValue) {
        setData(data);
        if (searchValue.length > 0) {
            setPageCount(0)
        }
    }

    useEffect(() => {
        getData()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <div className="page-header d-flex justify-content-between mb-2">
                <h4 className="vertical-center" onClick={tripleClick}>
                    {t('CLIENTS')}
                </h4>

                <div className="d-flex">
                    {canCreate &&
                        <button className="btn-rounded btn btn-primary" onClick={() => setShowModal(true)}>
                            <i className="uil uil-plus me-2"></i>
                            {t('CREATE')}
                        </button>
                    }
                </div>
            </div>

            <div className="card">
                <div className="card-body">
                    {showLoginForm && (
                        <div className="d-flex mb-3">
                            <form onSubmit={(e) => { e.preventDefault(); submitClients(); }}>
                                <input
                                    type="text"
                                    value={inputLoginValue}
                                    onChange={handleInputLoginChange}
                                    placeholder="Sdpos loginini kiriting"
                                />
                                <button type="submit">Import</button>
                            </form>
                        </div>
                    )}
                    <div className="d-flex mb-3 justify-content-between">
                        <div className="me-2">
                            <Search url={'/services/web/api/clients-pageList'} search={search} getData={getData}></Search>
                        </div>
                        <div className="d-flex gap-2">
                            <button
                                className="btn btn-outline-success"
                                onClick={() => setShowExcelModal(true)}
                            >
                                <i className="uil uil-upload me-2"></i>
                                {t('UPLOAD_FROM_EXCEL') || "Exceldan yuklash"}
                            </button>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-striped mb-0">
                            <thead>
                                <tr>
                                    <th>{t('NAME')}</th>
                                    <th>{t('PHONE')}</th>
                                    <th>{t('PHONE')}</th>
                                    <th>{t('COMMENT')}</th>
                                    <th className="text-center">{t('HIDE')}</th>
                                    <th className="text-center">{t('ACTION')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.name}</td>
                                        <td>{regexPhoneNumber(item.phone1)}</td>
                                        <td>{regexPhoneNumber(item.phone2)}</td>
                                        <td>{item.comment}</td>
                                        <td className="text-center">
                                            {item.hide ?
                                                <span>{t('YES')}</span>
                                                :
                                                <span>{t('NO')}</span>
                                            }
                                        </td>
                                        <td className="d-flex justify-content-center">
                                            {canUpdate &&
                                                <div className="table-action-button table-action-primary-button" onClick={() => openModal(item)}>
                                                    <i className="uil-edit-alt"></i>
                                                </div>
                                            }
                                        </td>
                                    </tr>
                                ))
                                }
                            </tbody>
                        </table>
                    </div>

                    <Pagination pageCount={pageCount} paginate={paginate}></Pagination>
                </div>
            </div>

            {/* MODAL */}
            <Modal show={showModal} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={() => closeModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {getValues('id') ?
                            <>{t('EDIT')}</>
                            :
                            <>{t('CREATE')}</>
                        }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit(createUpdate)} autoComplete="off">
                        <div className="form-group">
                            <label>{t('TITLE')}<span className="required-mark">*</span></label>
                            <input type="text" className="form-control" name="name" {...register('name', { required: true })} />
                            <span className="text-danger text-sm">{errors.name?.type === 'required' && t('required')}</span>
                        </div>
                        <div className="form-group">
                            <label>{t('PHONE')}<span className="required-mark">*</span></label>
                            <Controller
                                name="phone1"
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange, onBlur } }) => (
                                    <PhoneInput
                                        value={value || ''}
                                        onChange={(val) => onChange(val || '')}
                                        onBlur={() => {
                                            onBlur()
                                            const digits = regexNumeric(value || '')
                                            if (digits.length <= 3) onChange('')
                                        }}
                                        defaultCountry="UZ"
                                        international
                                        labels={en}
                                        numberInputProps={{ className: 'phone-input-number', placeholder: t('PHONE') }}
                                        className="PhoneInput--form PhoneInput--form--styled"
                                    />
                                )}
                            />
                            <span className="text-danger text-sm">{errors.phone1?.type === 'required' && t('required')}</span>
                        </div>
                        <div className="form-group">
                            <label>{t('PHONE')}</label>
                            <Controller
                                name="phone2"
                                control={control}
                                render={({ field: { value, onChange, onBlur } }) => (
                                    <PhoneInput
                                        value={value || ''}
                                        onChange={(val) => onChange(val || '')}
                                        onBlur={() => {
                                            onBlur()
                                            const digits = regexNumeric(value || '')
                                            if (digits.length <= 3) onChange('')
                                        }}
                                        defaultCountry="UZ"
                                        international
                                        labels={en}
                                        numberInputProps={{ className: 'phone-input-number', placeholder: t('PHONE') }}
                                        className="PhoneInput--form PhoneInput--form--styled"
                                    />
                                )}
                            />
                        </div>
                        <div className="form-group">
                            <label>{t('NOTE')}</label>
                            <input type="text" className="form-control" name="comment" {...register('comment')} />
                        </div>
                        <div className="d-flex justify-content-between">
                            <p className="fw-600 vertical-center">{t('HIDE')}</p>
                            <div className="form-check form-switch form-switch-lg">
                                <Controller
                                    name="hide"
                                    control={control}
                                    render={({ field: { value, onChange } }) => (
                                        <input type="checkbox" className="form-check-input" name="hide"
                                            checked={!!value}
                                            onChange={(e) => onChange(e.target.checked)}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                        <div className="d-flex w-100 mt-3">
                            <button type="button" className="btn btn-outline-warning w-100 me-2" onClick={() => closeModal()}>{t('CANCEL')}</button>
                            <button type="submit" className="btn btn-primary w-100">{t('SAVE')}</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            {/* MODAL */}

            {/* EXCEL UPLOAD MODAL */}
            <Modal show={showExcelModal} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={() => setShowExcelModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t('UPLOAD_FROM_EXCEL') || "Exceldan yuklash"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label>{t('CHOOSE_POS') || 'Savdo nuqtasini tanlang'}<span className="required-mark">*</span></label>
                        <Select
                            options={poses}
                            value={poses.find(p => p.id === selectedPosId)}
                            onChange={(option) => setSelectedPosId(option?.id)}
                            placeholder={t('CHOOSE_POS') || 'Savdo nuqtasini tanlang'}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable={false}
                        />
                    </div>
                    <div className="d-flex gap-2 mt-3">
                        <button
                            className="btn btn-outline-primary w-100"
                            onClick={downloadTemplate}
                        >
                            <i className="uil uil-download-alt me-2"></i>
                            {t('DOWNLOAD_TEMPLATE') || "Shablon yuklash"}
                        </button>
                    </div>
                    <div className="mt-3">
                        <input
                            type="file"
                            ref={fileInputRef}
                            accept=".xlsx, .xls"
                            style={{ display: 'none' }}
                            onChange={(e) => {
                                handleExcelUpload(e);
                                setShowExcelModal(false);
                            }}
                        />
                        <button
                            className="btn btn-success w-100"
                            onClick={() => {
                                if (!selectedPosId) {
                                    toast.warning(t('CHOOSE_POS') || 'Savdo nuqtasini tanlang');
                                    return;
                                }
                                fileInputRef.current.click();
                            }}
                        >
                            <i className="uil uil-upload me-2"></i>
                            {t('SELECT_FILE') || "Fayl tanlash"}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            {/* EXCEL UPLOAD MODAL */}
        </>
    )
}

export default Index
